// @flow

import styled, { css } from 'styled-components';

export const InputDate = styled.input.attrs({ type: 'date',  max: '2999-12-31' })`
  display: block;
  width: 100%;
  height: 50px;
  padding: 16px;
  border: 1px solid ${props => props.theme.colors.gray(88)};
  border-radius: calc(${props => props.theme.radius} / 2);
  outline: none;
  transition: box-shadow .5s, border-color .25s ease-in-out;

  :focus {
    border-color: var(--wlc-highlight-color, ${props => props.theme.colors.primary(50)});
    box-shadow: inset 0 0 0 1px var(--wlc-highlight-color, ${props => props.theme.colors.primary(50)});
  }

  ${props => props.fashion === 'error' && css`
    border-color: ${props => props.theme.colors.error(51)};
    background-color: ${props => props.theme.colors.error(95)};

    :focus {
      background-color: white;
      border-color: var(--wlc-highlight-color, ${props => props.theme.colors.primary(50)});
    }
  `}

  [dir=rtl] & {
    text-align: right;
  }
`;
